import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Checkbox from "@mui/material/Checkbox";
import JqxLoader from "jqwidgets-scripts/jqwidgets-react-tsx/jqxloader";
import JqxDateTimeInput from "jqwidgets-scripts/jqwidgets-react-tsx/jqxdatetimeinput";
import * as Util from "../../utils/util.js";
import BasicBackBoard from "../../components/BasicBackBoard";
import AutoCompleteInputTextField from "../../components/AutoCompleteInputTextField.js";

import PqGrid from "../../components/PqGrid";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#ABADB3",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white !important",
      borderRadius: "2px",
      fontFamily: `"Malgun Gothic", "맑은 고딕", AppleSDGothicNeo-Light, sans-serif`,
      "& fieldset": { color: "#ABADB3" },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(0, 176, 246, 1)",
      },
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "13px",
      paddingLeft: "6px",
      paddingRight: "6px",
    },
    "& .MuiIconButton-root": {
      padding: "1px",
      margin: "0px 2px",
    },
  },
})(TextField);

const useStyles = makeStyles(() => ({
  root: { flex: 1, width: "100%", marginTop: "0px" },

  spanVerticalAlign: {
    lineHeight: "26px",
  },

  clearIcon: {
    position: "relative",
    float: "right",
    left: "-620px",
    zIndex: 2,
  },

  cellStyle: { border: "1px solid" },

  textField: {
    width: "200px",
  },

  numberTextField: {
    fontSize: "14px",
    width: "60px",
    height: "26px",
  },

  span: {
    display: "inline-block",
    paddingTop: "3px",
    fontFamily: `"Malgun Gothic", "\B9D1\C740 \ACE0\B515", AppleSDGothicNeo-Light, sans-serif`,
    color: "#4e545f",
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "1.5em",
    whiteSpace: "nowrap",
    overflowX: "clip",
    marginLeft: "20px",
  },

  datePicker: {
    width: "165px",
    margin: 0,
    padding: 0,
    fontSize: "1px",
  },

  header: {
    width: "100%",
    marginTop: "10px",
    height: "50px",
    fontFamily: "NanumGothic",
  },

  footer: {
    position: "fixed",
    width: "100%",
    height: "35px",
    backgroundColor: "#DADADA",
    color: "white",
    bottom: 0,
  },
}));

function Menu4(props) {
  const classes = useStyles();
  const myLoader = useRef();
  const myCalendar = useRef();
  const thickF = useRef();
  const thickT = useRef();
  const widthF = useRef();
  const widthT = useRef();
  const lengthF = useRef();
  const lengthT = useRef();
  const [itemList, setItemList] = useState([]);
  const [culture, setCulture] = useState("ko-KR");
  const [packType, setPackName] = useState([
    "원재료",
    "상품",
    "잔여",
    "제품",
    "재공품",
    "Scrap",
    "T/E",
  ]);
  const refSearchSellCust = useRef();
  const refSearchVenCust = useRef();
  const refSearchDlvCust = useRef();
  const refSearchName = useRef();
  const refSearchStan = useRef();
  const refMillNo = useRef();

  const refPqGrid = useRef(null);
  const [onDisplay, setOnDisplay] = useState(false);

  useEffect(() => {
    if (props.name === props.selected) {
      setOnDisplay(true);
    } else {
      setOnDisplay(false);
    }
  }, [props.name, props.selected]);

  const columnLayout = [
    {
      title: "구분",
      dataIndx: "GBN_NAME",
      width: 70,
      editable: true,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "소유",
      dataIndx: "IM_NAME",
      width: 80,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "품명",
      dataIndx: "NAME_NAME",
      width: 80,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "재질",
      dataIndx: "STAN_NAME",
      width: 130,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "Size",
      dataIndx: "SIZE_NO",
      width: 135,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
    },
    {
      title: "수량",
      dataIndx: "STOCK_QUANTITY",
      width: 80,
      dataType: "float",
      format: "#,##0",
      summary: {
        type: "sum",
      },
      editable: false,
      styleHead: {
        "text-align": "center",
      },
      style: {
        "font-size": "14px",
      },
    },
    {
      title: "중량",
      dataIndx: "STOCK_WEIGHT",
      width: 110,
      dataType: "float",
      format: "#,##0.0",
      summary: {
        type: "sum",
      },
      editable: false,
      styleHead: {
        "text-align": "center",
      },
      style: {
        "font-size": "14px",
      },
    },
    {
      title: "입고일",
      dataIndx: "IN_DATE",
      width: 100,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
      style: {
        "font-size": "14px",
        "text-align": "center",
      },
    },
    {
      title: "제품번호",
      dataIndx: "COIL_NO",
      width: 140,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "소재번호",
      dataIndx: "MILL_NO",
      width: 100,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "포장번호",
      dataIndx: "PACK_NO",
      width: 105,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "계정",
      dataIndx: "STOCK_NAME",
      width: 90,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "수요가",
      dataIndx: "SELL_CUST_NAME",
      width: 200,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "사급업체",
      dataIndx: "VEN_CUST_NAME",
      width: 200,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "착지",
      dataIndx: "DLV_CUST_NAME",
      width: 200,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "하치장",
      dataIndx: "YARD_CUST_NAME",
      width: 160,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "적재위치",
      dataIndx: "POS_CD",
      width: 100,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
    },
    {
      title: "재고일수",
      dataIndx: "KEEP_DAY",
      width: 100,
      editable: false,
      styleHead: {
        "text-align": "center",
      },
      style: { "text-align": "right" },
    },
  ];

  function processData(data) {
    if (data.length > 0) {
      let codeCd = "";
      for (let i = 0; i < data.length; i++) {
        codeCd = codeCd + "'" + data[i].split(",") + "',";
      }
      codeCd = codeCd.substring(0, codeCd.length - 1);
      return codeCd;
    } else return "";
  }

  const MenuProps = {
    PaperProps: {
      style: {
        height: 550,
        width: 250,
      },
    },
  };

  const stk_list = ["원재료", "상품", "잔여", "제품", "재공품", "Scrap", "T/E"];

  const loadItem = () => {
    myLoader.current.open();

    let processPackType = processData(packType);
    axios
      .get(Util.getBaseUrl() + "Menu4/retrieve", {
        params: {
          isOutSider: Util.isOutsider(),
          date: new Date(
            myCalendar.current.getDate() -
              new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substring(0, 10)
            .replaceAll("-", ""),
          userId: window.sessionStorage.getItem("user_id"),
          myCustCd: window.sessionStorage.getItem("workplace_cd"),
          sellCustCd: refSearchSellCust.current.get().code,
          sellCustName: refSearchSellCust.current.get().input,
          venCustCd: refSearchVenCust.current.get().code,
          venCustName: refSearchVenCust.current.get().input,
          dlvCustCd: refSearchDlvCust.current.get().code,
          dlvCustName: refSearchDlvCust.current.get().input,
          nameName: refSearchName.current.get().input,
          stanName: refSearchStan.current.get().input,
          nameCd: refSearchName.current.get().code,
          stanCd: refSearchStan.current.get().code,
          thickF: thickF.current.value,
          thickT: thickT.current.value,
          widthF: widthF.current.value,
          widthT: widthT.current.value,
          lengthF: lengthF.current.value,
          lengthT: lengthT.current.value,
          stockName: processPackType,
          millNo: refMillNo.current.get().input,
        },
      })
      .then((response) => {
        if (response.data.code === "0") {
          myLoader.current.close();
          let res = response.data;
          setItemList(res.data);
        } else {
          alert(
            "조회된 내역이 없습니다.",
            myLoader.current.close(),
            setItemList([])
          );
        }
      })
      .catch((e) => {
        console.error(e); // 에러표시
        myLoader.current.close();
      });
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <BasicBackBoard>
          <div>
            <div className="d-flex p-1 pb-0 search-form-div">
              <div>
                <span className={classes.span}>기준일</span>
              </div>
              <div className="ms-2" onKeyDown={Util.enterToFocusMove}>
                <JqxDateTimeInput
                  textAlign="center"
                  ref={myCalendar}
                  animationType={"none"}
                  formatString={"yyyy-MM-dd"}
                  culture={culture}
                  width={130}
                  height={"26px"}
                />
              </div>
              <div style={{ display: Util.isOutsider() ? "none" : "flex" }}>
                <div style={{ marginLeft: "0px" }}>
                  <span className={classes.span}>수요가 </span>
                </div>
                <div className="ms-2">
                  <AutoCompleteInputTextField
                    ref={refSearchSellCust}
                    lists={JSON.parse(
                      window.sessionStorage.getItem("sellCustCd")
                    )}
                  />
                </div>
              </div>
              <div style={{ display: Util.isOutsider() ? "none" : "flex" }}>
                <div>
                  <span className={classes.span}>사급업체</span>
                </div>
                <div className="ms-2">
                  <AutoCompleteInputTextField
                    ref={refSearchVenCust}
                    lists={JSON.parse(
                      window.sessionStorage.getItem("sellCustCd")
                    )}
                  />
                </div>
              </div>
              <div style={{ display: Util.isOutsider() ? "none" : "flex" }}>
                <div>
                  <span className={classes.span}>착지</span>
                </div>
                <div className="ms-2">
                  <AutoCompleteInputTextField
                    ref={refSearchDlvCust}
                    lists={JSON.parse(
                      window.sessionStorage.getItem("sellCustCd")
                    )}
                  />
                </div>
              </div>
              <div>
                <span className={classes.span}>계정</span>
              </div>
              <div
                className="ms-2 ps-1 pe-0"
                style={{
                  height: "24px",
                  border: "1px solid #C4C4C4",
                  backgroundColor: "white",
                  overflowY: "hidden",
                }}
              >
                <div style={{ display: "inline-block" }}>
                  {stk_list.map((name) => (
                    <div className="me-5" style={{ display: "inline-block" }}>
                      <Checkbox
                        id={name}
                        value={name}
                        size="small"
                        sx={{ width: "26px", height: "26px" }}
                        defaultChecked={true}
                        onChange={(event) => {
                          setPackName((prev) => {
                            if (event.target.checked) {
                              return [...prev, event.target.value];
                            } else {
                              return prev.filter(
                                (item) => item !== event.target.value
                              );
                            }
                          });
                        }}
                        onKeyDown={Util.enterToFocusMove}
                      />
                      <label
                        style={{ fontSize: "12px", userSelect: "none" }}
                        htmlFor={name}
                      >
                        {name}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="d-flex mt-2 px-0 py-1 search-form-div">
              <div style={{ marginLeft: "14px" }}>
                <span className={classes.span}>품명</span>
              </div>
              <div className="ms-2 hidden-form">
                <AutoCompleteInputTextField
                  ref={refSearchName}
                  lists={JSON.parse(window.sessionStorage.getItem("code_nm"))}
                  width={100}
                />
              </div>
              <div style={{ marginLeft: "42px" }}>
                <span className={classes.span}>재질</span>
              </div>
              <div className="ms-2 hidden-form">
                <AutoCompleteInputTextField
                  ref={refSearchStan}
                  lists={JSON.parse(window.sessionStorage.getItem("code_stan"))}
                  width={140}
                />
              </div>
              <div style={{ marginLeft: "74px" }}>
                <span className={classes.span}>두께</span>
              </div>
              <div className="ms-2">
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  placeholder="0.0"
                  size="small"
                  inputRef={thickF}
                  variant="outlined"
                  className={classes.numberTextField}
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div className="mx-1 px-1">
                <object className={classes.spanVerticalAlign}>~</object>
              </div>
              <div>
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  placeholder="0.0"
                  inputRef={thickT}
                  size="small"
                  className={classes.numberTextField}
                  variant="outlined"
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div style={{ marginLeft: "63px" }}>
                <span className={classes.span}>폭</span>
              </div>
              <div className="ms-2">
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  size="small"
                  inputRef={widthF}
                  placeholder="0.0"
                  variant="outlined"
                  className={classes.numberTextField}
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div className="mx-1 px-1">
                <object className={classes.spanVerticalAlign}>~</object>
              </div>
              <div>
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  placeholder="0.0"
                  inputRef={widthT}
                  size="small"
                  className={classes.numberTextField}
                  variant="outlined"
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div style={{ marginLeft: "54px" }}>
                <span className={classes.span}>길이</span>
              </div>
              <div className="ms-2">
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  size="small"
                  inputRef={lengthF}
                  placeholder="0.0"
                  variant="outlined"
                  className={classes.numberTextField}
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div className="mx-1 px-1">
                <object className={classes.spanVerticalAlign}>~</object>
              </div>
              <div>
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  inputRef={lengthT}
                  placeholder="0.0"
                  size="small"
                  className={classes.numberTextField}
                  variant="outlined"
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div style={{ marginLeft: "38px" }}>
                <span className={classes.span}>소재번호</span>
              </div>
              <div className="ms-2">
                <AutoCompleteInputTextField
                  ref={refMillNo}
                  lists={[]}
                  width={90}
                />
              </div>
              <div className="d-flex" style={{ marginLeft: "38px" }}>
                <Button
                  className="d-btn primary"
                  onClick={() => loadItem()}
                  variant="contained"
                >
                  조회
                </Button>
                <Button
                  className="d-btn primary"
                  onClick={() => {
                    refPqGrid.current?.exportExcel("재고현황");
                    Util.setMonitoring(
                      window.sessionStorage.getItem("user_id"),
                      "재고현황",
                      "엑셀"
                    );
                  }}
                  variant="contained"
                >
                  엑셀
                </Button>
              </div>
            </div>
          </div>
        </BasicBackBoard>
        <div className={classes.root}>
          <>
            <JqxLoader ref={myLoader} width={100} height={60} />
            <PqGrid
              name={props.name}
              ref={refPqGrid}
              width={"100%"}
              columns={columnLayout}
              dataModel={itemList}
              display={onDisplay}
              retrieve={loadItem}
            />
          </>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Menu4);
